import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncTidalToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncTidalToAppleMusic}
            sections={<PairSyncGuideContent sourceKey="tidal" destKey="appleMusic" />}
        />
    );
}
